import _jsx from "@babel/runtime/helpers/jsx";
/* global dmiVideo */
import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { injectScript } from '@atc/dom-fns';

/**
 * The liquidus player leverages a 3rd party library injected in to the DOM. This component creates an instance of the player along with
 * controls and callbacks. All properties of the video instance are stored in 'this.player'
 */

function LiquidusPlayer(_ref) {
  let {
    autostart = '0',
    className,
    config,
    height,
    onCompleted,
    onPlay,
    onPlayerReady,
    onReplay,
    src,
    videoId,
    width,
    placeholder
  } = _ref;
  const player = useRef(null);
  const referencePlayer = useRef(null);
  const containerElement = useRef(null);
  const [isVideoReady, setIsVideoReady] = useState(false);
  const load = () => {
    /**
     * Callback used for Liquidus Player's VideoCallback option.
     * @param videoPlayer
     * @param eventName
     *
     * Append the player callbacks to global namespace.
     * Liquidus player looks for callbacks in the global scope.
     */
    window.liquidusPlayerCallbacks = (videoPlayer, eventName) => {
      const {
        isPlaying,
        suppressPlayEvent
      } = dmiVideo;
      switch (eventName) {
        case 'Ready':
          player.current = videoPlayer.data.Player;
          onPlayerReady();

          // Toggle play/pause on video click
          videoPlayer.onclick = () => {
            if (isPlaying) {
              dmiVideo.isPlaying = false;
              player.current.pause();
            } else {
              dmiVideo.isPlaying = true;
              player.current.play();
            }
          };
          break;
        case 'Play':
          dmiVideo.isPlaying = true;
          if (!suppressPlayEvent) {
            onPlay();
            dmiVideo.suppressPlayEvent = true;
          }
          break;
        case 'Pause':
          dmiVideo.isPlaying = false;
          break;
        case 'ControlPlay':
          dmiVideo.isPlaying = true;
          break;
        case 'Replay':
        case 'ControlReplay':
          onReplay();
          break;
        case 'Complete':
          dmiVideo.isPlaying = false;
          onCompleted();
          break;
        default:
      }
    };

    // parse vid from video src for all liquidus eligible video sources(liquidus, aqueousdt and dmotorworks)
    const vid = new URLSearchParams(src.split('?')[1]).get('vid');
    dmiVideo.load({
      site: 'Autotrader',
      PlayerTarget: referencePlayer.current.id,
      mediaID: vid,
      w: width,
      h: height,
      NoMenu: 'All',
      NoOverlays: 'NoLinks',
      AutoPlay: autostart ? '1' : '0',
      VideoCallback: 'window.liquidusPlayerCallbacks'
    });
    dmiVideo.id = videoId;
    dmiVideo.isPlaying = false;
    dmiVideo.suppressPlayEvent = false;
    setIsVideoReady(true);
  };
  useEffect(() => {
    containerElement.current = referencePlayer.current;
    if (typeof dmiVideo === 'undefined') {
      injectScript(config.LIQUIDUS_VIDEO.LIQUIDUS_JS).then(() => {
        load();
      });
    } else {
      load();
    }
    return () => {
      if (player.current) {
        player.current.pause();
      }
    };
  });
  useEffect(() => {
    if (player.current) {
      player.current.pause();
    }
  }, [player]);
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "liquidusPlayer",
    className: `${className || ''} video-player liquidus-player`
  }, void 0, !isVideoReady && placeholder, /*#__PURE__*/React.createElement("div", {
    id: `v${videoId}`,
    ref: referencePlayer
  }));
}
export default LiquidusPlayer;